// path: src/pages/IPA/Negociacoes/pages/NegociacaoFornecedor/ordenacaoDaVisaoRede.ts

/** Quais colunas a visão rede oferece para ordenar. */
export const COLUNAS_ORDENAVEIS_NA_VISAO_REDE = [
  'stock_quantity',
  'cost',
  'price_retail',
  'competitors_price',
] as const;

export type ColunaOrdenavelNaVisaoRede = (typeof COLUNAS_ORDENAVEIS_NA_VISAO_REDE)[number];

/** Se a coluna oferece ordenação na visão em uso. */
export const ordenaNaVisao = (chaveDaColuna: string, ehVisaoRede: boolean): boolean =>
  ehVisaoRede
    ? (COLUNAS_ORDENAVEIS_NA_VISAO_REDE as readonly string[]).includes(chaveDaColuna)
    : true;
